import { Layout } from "@/components/layout"
import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export const NotFound = () => (
  <Layout>
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <span className="text-8xl font-bold text-rose-400">404</span>
      <h1 className="mt-4 text-2xl font-bold">Page not found</h1>
      <p className="mt-2 text-muted-foreground">
        The page you're looking for doesn't exist.
      </p>
      <a
        href="/"
        className={cn(buttonVariants({ variant: "outline" }), "mt-8")}
      >
        Go home
      </a>
    </div>
  </Layout>
)
